import { jsx as e, jsxs as n, Fragment as p } from "react/jsx-runtime";
import { Tooltip as c } from "@mui/material";
import { Typography as i } from "../Typography/index.js";
const f = ({
  children: a,
  title: o,
  subtitle: r,
  custom: t,
  ...l
}) => {
  if (!o && !r && !t)
    throw new Error("Tooltip requires at least one of 'title', 'subtitle', or 'custom' to be provided.");
  return /* @__PURE__ */ e(
    c,
    {
      title: t || /* @__PURE__ */ n(p, { children: [
        o && /* @__PURE__ */ e(i, { variant: "h5", color: "var(--otc-green)", children: o }),
        r && /* @__PURE__ */ e(i, { variant: "subtitle2", color: "var(--otc-black)", mt: 0.5, children: r })
      ] }),
      ...l,
      children: a
    }
  );
};
export {
  f as Tooltip,
  f as default
};
